import React from "react";
import ReactDOM from "react-dom/client";
import App from "@/App";

// The public landing pages are fully static HTML.
// Only mount React when an explicit #root element is present
// (kept for compatibility with future React routes).
const rootEl = document.getElementById("root");
if (rootEl) {
  const root = ReactDOM.createRoot(rootEl);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
